import { Badge, Divider, List, ListItem, ListItemButton, ListItemText, ListSubheader, Popover, Tooltip, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { displayNotification, getBaseURL, handleRequest } from '../../helpers';
import { useSelector } from 'react-redux';
import { Bell } from 'lucide-react';

const Notifications = () => {

    const { t } = useTranslation();
    const user = useSelector((s) => s.auth.data);

    const [anchorEl, setAnchorEl] = useState(null);
    const [data, setData] = useState([]);

    const handleClick = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    useEffect(() => {
        // loadData();
        // const loader = setInterval(loadData, 10 * 1000);
        // return () => clearInterval(loader);
    }, []);

    const loadData = async () => {
        try {
            const res = await handleRequest(`/notifications?user_id=${user.id}`);
            if (res.success) {
                setData(res.data);
            } else {
                displayNotification('error', `${t("960", "Error loading notifications")} [B]`);
            }
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("960", "Error loading notifications")} [F]`);
        }
    };

    const readNotification = async (id) => {
        try {
            const res = await handleRequest(
                `/notifications/${id}`,
                'POST'
            );
            if (res.success) {
                await loadData();
            }
        } catch (e) {
            console.log(e)
        }
    }

    const unreadCount = data.filter(r => !r.is_read).length;

    return (
        <>
            <Tooltip title={t("715", "Notifications")}>
                <button
                    type="button"
                    className="portal-header-icon-btn position-relative"
                    onClick={handleClick}
                    aria-label="Notifications"
                >
                    <Bell size={17} />
                    {unreadCount > 0 && (
                        <span className="badge-dot">
                            {unreadCount > 9 ? '9+' : unreadCount}
                        </span>
                    )}
                </button>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    '& .MuiPopover-paper': {
                        width: 300
                    }
                }}
            >
                <Typography sx={{ p: 2, textAlign: 'center' }}>
                    <h3 className='text-dark'>
                        {t("715", "Notifications")}
                    </h3>
                </Typography>
                <List
                    sx={{
                        width: '100%',
                        maxWidth: 300,
                        bgcolor: 'var(--theme-light)',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 300,
                        '& ul': { padding: 0 },
                        '& .MuiDivider-inset': { margin: 0 },
                    }}
                    subheader={<li />}
                >
                    {
                        data.length > 0 ? (
                            data.map(noti => (
                                <Fragment key={`notification-${noti}`}>
                                    <ListItemButton
                                        sx={{ p: 0 }}
                                        selected={!noti.is_read}
                                        onClick={()=>readNotification(noti.id)}
                                    >
                                        <ListItem>
                                            <ListItemText primary={noti.content} />
                                        </ListItem>
                                    </ListItemButton>
                                    <Divider variant="inset" component="li" />
                                </Fragment>
                            ))
                        ) : (
                            <>
                                <ListItem>
                                    <ListItemText
                                        primary={t("959", "No Notifications Available")}
                                        sx={{ textAlign: 'center' }}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        )
                    }
                </List>
            </Popover>
        </>
    );
}

export default Notifications;
